import { InsertDriveFile, PictureAsPdf } from '@mui/icons-material';
import React from 'react';

import { getFileExtension } from './FolderPathUtil';

export const getIconForFile = (fileName: string) => {
  const ext = getFileExtension(fileName).toLowerCase();
  if (ext === 'pdf') return <PictureAsPdf sx={{ color: '#D44333', mr: 1 }} />;
  if (ext.startsWith('xls')) return <InsertDriveFile sx={{ color: 'green', mr: 1 }} />;
  return <InsertDriveFile sx={{ color: 'blue', mr: 1 }} />;
};
